import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import purgeCorporateCardConnection, {
  depurgeCorporateCardConnection,
} from '~apis/corporate-card/deleteCorporateCardConnections';
import getCorporateCardConnections from '~apis/corporate-card/getCorporateCardConnections';

export const USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY = {
  root: ['corporate-card-connections'],
  default: (companyId: string) => [...USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY.root, companyId],
};
export default function useGetCorporateCardConnections(companyId: string) {
  return useQuery(
    USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY.default(companyId as string),
    () => getCorporateCardConnections(companyId),
    {
      enabled: !!companyId,
      cacheTime: 0,
    },
  );
}
export function usePurgeCorporateCardConnection(companyId: string, connectionId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => purgeCorporateCardConnection(companyId, connectionId),
    onSuccess: () => {
      queryClient.invalidateQueries(USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY.root);
    },
  });
}

export function useDepurgeCorporateCardConnection(companyId: string, connectionId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => depurgeCorporateCardConnection(companyId, connectionId),
    onSuccess: () => {
      queryClient.invalidateQueries(USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY.root);
    },
  });
}
